import { environment } from '../../environments/environment';

// Local testing switch: set `skipValidation: true` in the (gitignored) environment.ts to go through the
// sign-up steps without filling in the fields. Environments without the property keep validation on.
export const skipFormValidation: boolean = (environment as { skipValidation?: boolean }).skipValidation === true;
